export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7720.3e30c2cb.jpg";